import React from 'react';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { useTranslation } from 'react-i18next';
import { NodeDocument } from '../../../../types/nodes';
import TeaserSmall from '../../../../components/Teaser/Small';

import './style.scss';
import TeaserBig from '../../../../components/Teaser/Big';

const MAGAZINE_TYPE = 'Magazine';

interface NodeDocumentTeaserProps extends React.ComponentPropsWithoutRef<'div'> {
  entity: ImmutableEntity<NodeDocument>;
}

const NodeDocumentTeaser: React.FC<NodeDocumentTeaserProps> = ({ entity }) => {
  const { t } = useTranslation();
  const node = entity.toJS();
  const type = node.field_media_category[0]?.entity.name[0].value || t('content_types.document.type');

  if (type === MAGAZINE_TYPE) {
    return (
      <div className="NodeDocumentTeaser--Magazine">
        <TeaserBig node={node} typeLabel={type} />
      </div>
    );
  }

  return (
    <div className="NodeDocumentTeaser">
      <TeaserSmall node={node} typeLabel={type} />
    </div>
  );
};

export default NodeDocumentTeaser;
